{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Skatiet visas opcijas",
  "Spoiler_Reveal_Tooltip": "Noklikšķiniet, lai atklātu",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Ietvītot šo",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Vienums ir sakļauts",
  "Spoiler_Reveal_Video_CTA": "Atklāt video",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Izvērst attēlu",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Skatīt visus rezultātus",
  "Spoiler_Reveal_Image_Placeholder": "Šajā attēlā ir spoileris",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Meklēšanas slīdnis",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Balsot var par vairākām atbildēm.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Rādīt vairāk audio vadības elementu",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Aizvērt",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Notiek {{fileType}} ielāde",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Lasīt vairāk",
  "Spoiler_Insert_Tooltip": "Spoileris",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Skaļums",
  "Spoiler_Reveal_Gallery_Placeholder": "Šajā galerijā ir spoileris",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Rezervējiet tūlīt",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Atcelt apklusināšanu",
  "Spoiler_Reveal_Gallery_CTA": "Atklāt galeriju",
  "Poll_Viewer_ShowLess_CTA": "Rādīt mazāk",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Apklusināt",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonīmi",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Sekot",
  "VerticalEmbed_Products_Button": "Pērciet tūlīt",
  "Poll_Viewer_Toast_Error_ServerDown": "Nevarēja izveidot savienojumu ar serveri. Vēlāk mēģiniet vēlreiz.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} persona(-s) balsoja par šo atbildi",
  "Poll_Viewer_VoteCount": "{{number}} balss(-is)",
  "VerticalEmbed_Events_Button": "Reģistrējieties tūlīt",
  "Spoiler_Reveal_Image_CTA": "Atklāt attēlu",
  "Poll_Viewer_Toast_Error_Connection": "Nav interneta. Pārbaudiet savienojumu.",
  "Poll_Viewer_Visibility_Owner_Footer": "Tikai Jūs varat redzēt rezultātus.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} persona(-s) balsoja par šo atbildi",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Vienums ir izvērsts",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Šajā video ir spoileris",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Skatīt pilnu ziņu",
  "UploadFile_Viewer_Download": "Lejupielādēt {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} h",
  "VerticalEmbed_Units_Minute": "{{minutes}} min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
